import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/** Keeps the case table mounted while a routed case opens in its place. */
@Component({
  selector: 'app-crm-cases-workspace',
  templateUrl: './cases-workspace.component.html',
  host: { class: 'workspace-master-detail-page' },
})
export class CrmCasesWorkspaceComponent {
  get detailOpen(): boolean { return this.route.firstChild !== null; }

  constructor(private readonly route: ActivatedRoute) {}
}
